module.exports = __webpack_public_path__ + "static/img/favicon2.b0c98f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon2.png
// module id = rLwW
// module chunks = 1